import { evalCurve } from './math/curve.js';
import { evalGradient } from './math/gradient.js';
import { randRange } from './math/prng.js';
export function evalScalarAtBirth(p, ctx) {
    switch (p.type) {
        case 'constant':
            return p.value;
        case 'randomBetween':
            return randRange(ctx.rng, p.a, p.b);
        case 'curve':
            return evalCurve(p.curve, ctx.normTime) * (p.scale ?? 1);
        case 'curveRandom':
            return evalCurve(p.curve, ctx.normTime) * randRange(ctx.rng, p.min, p.max);
    }
}
export function evalColorAtBirth(p, ctx, out = [1, 1, 1, 1]) {
    switch (p.type) {
        case 'constant':
            out[0] = p.value[0];
            out[1] = p.value[1];
            out[2] = p.value[2];
            out[3] = p.value[3];
            return out;
        case 'randomBetween': {
            const s = ctx.rng();
            for (let c = 0; c < 4; c++)
                out[c] = p.a[c] + (p.b[c] - p.a[c]) * s;
            return out;
        }
        case 'gradient': {
            const t = (p.by ?? 'random') === 'spawn' ? ctx.normTime : ctx.rng();
            return evalGradient(p.gradient, t, out);
        }
    }
}
/**
 * Reference CPU evaluation of an over-lifetime provider — mirrors what the GPU
 * does with the baked atlas. Used by tests and by CPU-side modules
 * (velocityOverLife). `birthRand` is the particle's stored random in [0,1).
 */
export function evalScalarOverLife(p, nAge, birthRand) {
    switch (p.type) {
        case 'constant':
            return p.value;
        case 'randomBetween':
            return p.a + (p.b - p.a) * birthRand;
        case 'curve':
            return evalCurve(p.curve, nAge) * (p.scale ?? 1);
        case 'curveRandom':
            return evalCurve(p.curve, nAge) * (p.min + (p.max - p.min) * birthRand);
    }
}
